import TouchGestures from './lib_components/touch-gestures';
import IM from './utils/global-object';

IM.init();

export default TouchGestures;
